"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefix = exports.default = void 0;
var prefix = exports.prefix = '_ah_ob';
var obfuscateString = function obfuscateString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (string.startsWith(prefix)) {
    return string;
  }
  var encoded;
  if (typeof window !== 'undefined' && window.btoa) {
    encoded = window.btoa(string);
  } else {
    encoded = Buffer.from(string).toString('base64');
  }
  return "".concat(prefix).concat(encoded);
};
var _default = exports.default = obfuscateString;